import React from 'react';
import * as yup from 'yup';
import FormSection from '../../../../common/hookFormComponents/FormSection';
import { mobileNoValidation } from '../../../../../util/yupUtils';

const fields = [
  {
    colSpan: 2,
    name: 'mdName',
    type: 'text',
    isRequired: true,
    label: 'Name of Managing Director',
  },
  {
    colSpan: 1,
    name: 'mdOfficeTelephone',
    type: 'text',
    isRequired: true,
    label: 'Office Telephone',
  },
  {
    colSpan: 1,
    name: 'mdResidenceTelephone',
    type: 'text',
    isRequired: true,
    label: 'Residence Telephone',
  },
  {
    colSpan: 1,
    name: 'mdMobileNo',
    type: 'text',
    isRequired: true,
    label: 'Mobile Number',
  },
  {
    colSpan: 1,
    name: 'mdEmail',
    type: 'text',
    isRequired: true,
    label: 'Email Address',
  },
];

export const managingDirectorFieldsValidation = {
  [fields[0].name]: yup.string().required().label(fields[0].label),
  [fields[1].name]: mobileNoValidation.required().label(fields[1].label),
  [fields[2].name]: mobileNoValidation.required().label(fields[2].label),
  [fields[3].name]: mobileNoValidation.required().label(fields[3].label),
  [fields[4].name]: yup.string().email().required().label(fields[4].label),
};

const ManagingDirectorSection = (props) => {
  return (
    <FormSection
      autoFill
      autoFillMsg="Same as Chairman Information"
      sectionName="Managing Director Information"
      sectionColumn={2}
      formFields={fields}
      {...props}
    />
  );
};

export default ManagingDirectorSection;
